import "../resources/css/common/common.scss";
import React, { Component } from "react";

// const NotFoundPage = () => {
//   <div className='page_not_found'>
//     <h3>404 page not found</h3>
//     <p>We are sorry but the page you are looking for does not exist.</p>
//   </div>
// }

class NotFoundPage extends Component {
  render() {
    return (
      <div className="page_not_found">
        <h3>404 page not found</h3>
        <p>We are sorry but the page you are looking for does not exist.</p>
      </div>
    );
  }
}
export default NotFoundPage;
